<template>
  <fragment>
    <div class="col-12 col-lg-8">
      <div class="dash-section contains-list">
        <div class="header mb-2">
          <div>
            <span v-if="feedbackMetrics.loading" class="title">
              <skeleton width="75px" height="20px"/>
            </span>
            <h2 v-else class="title">
              {{ feedbackMetrics.metrics.feedbackCount }} Responses
            </h2>
          </div>
        </div>
        <feedback-list class="dash-sub-section mt-0"/>
      </div>
    </div>
    <feedback-metrics class="col-12 col-lg-4" />
  </fragment>
</template>

<script>
import Skeleton from '../../Skeleton.vue'
import FeedbackList from './components/FeedbackList.vue'
import FeedbackMetrics from './components/FeedbackMetrics.vue'

export default {
  name: 'FeedbackTab',

  components: {
    FeedbackList,
    FeedbackMetrics,
    Skeleton,
  },

  inject:['feedbackMetrics'],

  mounted(){
    this.feedbackMetrics.fetch()
  },
};
</script>

<style lang="scss" scoped>
.dash-section.contains-list {
  min-height: 350px;
}
</style>
